import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantsAction } from "../../store/actions/restaurantsAction";
import { updateTip } from "../../store/actions/cartAction";
import {
  getPaymentMethodAction,
  updateOrderAction,
} from "../../store/actions/orderAction";
import PaymentMethod from "../Tip/PaymentMethod";
import TipInput from "../Tip/TipInput";
import TipModalHeader from "../Tip/TipModalHeader";
import PaymentProviders from "../Tip/PaymentProviders";
import PaymentSecurityInfo from "../Tip/PaymentSecurityInfo";
import ModalFooterButtons from "../Tip/ModalFooterButtons";

const TipModal = ({
  restaurantID,
  OrderId,
  price,
  currency,
  modal,
  setModal,
  darkMode,
  color,
  args,
  setTipAdded,
}) => {
  const dispatch = useDispatch();
  const { restaurantsDetail } = useSelector((state) => state.restaurants);
  const { user, uid } = useSelector((state) => state.authUser);
  const { loader } = useSelector((state) => state.orders);
  const { tipDetails } = useSelector((state) => state.cart);
  const { orderHistory } = useSelector((state) => state.orders);
  const matchedItem = orderHistory.filter((item) => item.id === OrderId);
  const [renderCards, setRenderCards] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [tipAmountValue, setTipAmountValue] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [tip, setTip] = useState(0);
  const [tipType, setTipType] = useState("");
  const [activeStep, setActiveStep] = useState(1);

  const tipButtons = restaurantsDetail?.tipPercentages || [];
  const paypalFees = restaurantsDetail?.forwardFees?.find(
    (val) => val?.provider === "paypal"
  );
  const stripeFees = restaurantsDetail?.forwardFees?.find(
    (val) => val?.provider === "stripe"
  );

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleTipSelect = (tip, index) => {
    const numericTip = Number(tip.replace("%", ""));
    setTipAmountValue(tip);
    dispatch(
      updateTip({
        tip: numericTip,
        tipType: "percentage",
        tipIndex: index,
      })
    );
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setTipAmountValue(value);
    if (value !== "") {
      dispatch(updateTip({ tip: Number(value), tipType: "fixed" }));
    } else {
      dispatch(updateTip({ tip: 0, tipType: "" }));
    }
  };

  const handleNext = () => {
    if (!tipAmountValue) {
      toast.error("Please add a tip to proceed");
      return;
    }
    setActiveStep(activeStep + 1);
  };

  const handlePrev = () => {
    if (activeStep > 1) setActiveStep(activeStep - 1);
    setPaymentMethod("");
  };

  const handlePaymentSelection = (method) => {
    setPaymentMethod(method);
    setRenderCards(method === "Stripe" || method === "Paypal");
  };

  const handleAddTip = () => {
    const payload = {
      OrderId,
      tip,
      tipType,
      paymentMethod,
      totalAmount: tipAmountValue,
    };
    dispatch(
      updateOrderAction(payload, () => {
        setTipAdded(true);
        setTipAmountValue("");
      })
    );
    setModal(false);
  };

  useEffect(() => {
    if (modal) {
      setTipAmountValue("");
      setActiveStep(1);
      setPaymentMethod("");
    }
  }, [modal]);

  useEffect(() => {
    if (tipDetails) {
      if (tipDetails?.tipType === "fixed") {
        setTip(tipDetails?.tip);
        setTipType(tipDetails?.tipType);
        setTipAmountValue(tipDetails?.tip);
      } else if (tipDetails?.tipType === "percentage") {
        setTipType(tipDetails?.tipType);
        setTip(tipDetails?.tip);
        setTipAmountValue(tipDetails?.tip);
      }
    }
  }, [tipDetails]);

  useEffect(() => {
    if (restaurantID) {
      dispatch(getRestaurantsAction(restaurantID));
    }
  }, [dispatch, restaurantID]);

  useEffect(() => {
    dispatch(getPaymentMethodAction(uid));
  }, [dispatch, uid]);

  return (
    <Modal
      isOpen={modal}
      toggle={() => setModal(!modal)}
      {...args}
      style={{ maxHeight: "90vh", marginTop: "100px" }}
    >
      <TipModalHeader
        activeStep={activeStep}
        toggleModal={() => setModal(!modal)}
        color={color}
      />

      <ModalBody style={{ minWidth: "100%" }}>
        {activeStep === 1 && (
          <TipInput
            tipButtons={tipButtons}
            handleTipSelect={handleTipSelect}
            handleInputChange={handleInputChange}
            tipAmountValue={tipAmountValue}
            dropdownOpen={dropdownOpen}
            toggleDropdown={toggleDropdown}
            darkMode={darkMode}
            color={color}
            currency={currency}
          />
        )}

        {activeStep === 2 && (
          <PaymentMethod
            paymentMethod={paymentMethod}
            tipAmountValue={tipAmountValue}
            currency={currency}
            matchedItem={matchedItem}
            handlePaymentSelection={handlePaymentSelection}
            darkMode={darkMode}
            color={color}
            restaurantsDetail={restaurantsDetail}
          />
        )}

        <div className="d-flex flex-column justify-content-center align-items-center w-100">
          <PaymentProviders
            paymentMethod={paymentMethod}
            renderCards={renderCards}
            restaurantsDetail={restaurantsDetail}
            darkMode={darkMode}
            tipAmountValue={tipAmountValue}
            currency={currency}
            price={price}
            uid={uid}
            user={user}
            paypalFees={paypalFees}
            stripeFees={stripeFees}
            OrderId={OrderId}
            tip={tip}
            tipType={tipType}
            dispatch={dispatch}
            setTipAdded={setTipAdded}
            setTipAmountValue={setTipAmountValue}
            setModal={setModal}
            setPaymentMethod={setPaymentMethod}
          />
        </div>

        {activeStep !== 1 && <PaymentSecurityInfo darkMode={darkMode} />}
      </ModalBody>

      <ModalFooterButtons
        activeStep={activeStep}
        handlePrev={handlePrev}
        handleNext={handleNext}
        paymentMethod={paymentMethod}
        handleAddTip={handleAddTip}
        loader={loader}
        color={color}
      />
    </Modal>
  );
};

export default TipModal;
